const TH = {
  header: {
    search: "ค้นหา",
    library: "กฎหมาย",
    compare: "เปรียบเทียบ",
    placeholder: "ค้นหากฎหมาย ข้อหารือ เลขที่หนังสือ หรือเรื่องภาษี",
    submit: "ค้นหา",
    searching: "กำลังค้นหา…",
    language: "ภาษา",
    english: "อังกฤษ",
    type: "ประเภท",
    year: "ปี",
    filters: "ตัวกรองผลการค้นหา",
    all: "ทั้งหมด",
    allYears: "ทุกปี",
    uiLanguage: "ภาษาของหน้าจอ",
    documentLanguage: "ภาษาของเอกสาร",
    menu: "เมนูหลัก",
    searchLabel: "ค้นหากฎหมาย",
    openFilters: "แสดงตัวกรอง",
    closeFilters: "ซ่อนตัวกรอง",
    activeFilters: "ตัวกรอง: {{selection}}",
    noActiveFilters: "ตัวกรอง",
    selectedLanguageThai: "ภาษาไทย",
    selectedLanguageEnglish: "ภาษาอังกฤษ",
  },
  common: {
    close: "ปิด",
    back: "ย้อนกลับ",
    loading: "กำลังเปิดข้อมูล…",
    unknown: "ยังไม่ระบุ",
    notAvailable: "ยังระบุไม่ได้",
    open: "เปิด",
    copy: "คัดลอก",
    copied: "คัดลอกแล้ว",
    source: "แหล่งที่มา",
    publisher: "หน้าที่เผยแพร่",
    preservedFile: "ฉบับอ่านสะอาด",
    citation: "คำอ้างอิง",
    noLink: "ยังไม่พบลิงก์ที่เปิดได้",
    noFile: "ยังไม่พบฉบับอ่านสะอาด",
    readingCopy: "ฉบับอ่านสะอาด",
    download: "ดาวน์โหลดฉบับอ่านสะอาด",
  },
  browse: {
    aria: "สำรวจคลังกฎหมาย",
    eyebrow: "สำรวจคลังกฎหมาย",
    title: "สำรวจคลังกฎหมายภาษี",
    paths: "วิธีสำรวจคลัง",
    retry: "ลองเปิดคลังอีกครั้ง",
    root: "ลำดับชั้นกฎหมาย",
    breadcrumb: "ตำแหน่งในคลังกฎหมาย",
    loading: "กำลังเปิดคลังกฎหมาย…",
    catalogError: "ไม่สามารถเปิดสารบัญคลังกฎหมายได้",
    listError: "ไม่สามารถเปิดรายการเอกสารในหมวดนี้ได้",
    revenueError: "ไม่สามารถเปิดสารบัญประมวลรัษฎากรได้",
    allYears: "ดูทั้งหมดทุกปี",
    undatedYear: "ยังไม่ระบุปี",
    undatedHelp: "กดเพื่อดูเอกสารที่ยังไม่ระบุปี",
    yearHelp: "กดเพื่อดูรายชื่อเอกสาร",
    sections: "มาตรา",
    subsections: "หมวดย่อย",
    source: "หน้าที่เผยแพร่",
    detailContents: "สารบัญฉบับละเอียด",
    selectWithoutSearch: "เลือกดูโดยไม่ต้องพิมพ์ค้นหา",
  },
  results: {
    aria: "ผลการค้นหา",
    eyebrow: "ผลการค้นหา",
    count: "{{count}} รายการ",
    sort: "เรียงลำดับ",
    relevance: "เกี่ยวข้องที่สุด",
    newest: "ใหม่–เก่า",
    oldest: "เก่า–ใหม่",
    byType: "ตามประเภท",
    byYear: "ตามปี",
    empty: "ไม่พบเอกสารที่ตรงกัน",
    start: "เริ่มต้นด้วยคำค้นหรือเลขหนังสือ",
    description: "ค้นจากข้อความของเอกสาร ไม่ได้อาศัยชื่อเรื่องเพียงอย่างเดียว",
    searchError: "ไม่สามารถค้นหาได้ โปรดลองอีกครั้ง",
    underReview: "อยู่ระหว่างการตรวจทาน",
    approved: "ตรวจแล้ว",
    undated: "ไม่ระบุปี",
  },
  reader: {
    loading: "กำลังเปิดเอกสาร…",
    empty: "เลือกเอกสารเพื่ออ่านเนื้อหาและตรวจสอบที่มา",
    backSearch: "กลับไปผลการค้นหา",
    backBrowse: "กลับไปคลังกฎหมาย",
    fontSize: "ขนาดตัวอักษร",
    decreaseFont: "ลดขนาดตัวอักษร",
    resetFont: "คืนขนาดตัวอักษร",
    increaseFont: "เพิ่มขนาดตัวอักษร",
    focusOn: "กลับหน้าค้นคว้า",
    focusOff: "โหมดอ่านเต็มจอ",
    hideOutline: "ซ่อนโครงสร้าง",
    showOutline: "แสดงโครงสร้าง",
    continuousOn: "อ่านต่อเนื่อง",
    continuousOff: "เปิดทีละส่วน",
    addCompare: "+ เพิ่มเพื่อเปรียบเทียบ",
    citedDocuments: "เอกสารที่อ้างถึง",
    sourceAndRelated: "แหล่งที่มา",
    toolbar: "เครื่องมืออ่านเอกสาร",
    structureAndContext: "โครงสร้างและบริบท",
    documentDates: "ประวัติวันที่ของเอกสาร",
    textUnavailable: "ยังไม่มีข้อความพร้อมอ่าน เปิดต้นฉบับเพื่อดูเอกสารจากผู้เผยแพร่",
    applicableLaw: "ข้อกฎหมาย",
    question: "ข้อหารือ",
    holding: "แนววินิจฉัย",
    page: "หน้า",
    preamble: "บทนำ",
    provision: "บทบัญญัติ",
    parties: "คู่ความ",
    issue: "ประเด็น",
    sourceAttribution: "แหล่งที่มา",
    outline: "โครงสร้างเอกสาร",
    outlineTitle: "โครงสร้างบทบัญญัติ",
    documentParts: "ส่วนของเอกสาร",
    thai: "ไทย",
    english: "English",
    parallel: "ไทย–English",
    parallelSide: "เลือกฝั่งอ่านไทย–อังกฤษ",
    languageControlNote: "เลือกภาษาเพื่ออ่านฉบับที่มีอยู่",
    translationTitle: "ชื่อเรื่องภาษาอังกฤษ",
    titleInThai: "ชื่อเรื่องภาษาไทย",
    titleInEnglish: "ชื่อเรื่องภาษาอังกฤษ",
    thaiOriginalOnly: "มีต้นฉบับภาษาไทยเท่านั้น",
    translationDraft: "ชื่อเรื่องนี้เป็นฉบับร่างภาษาอังกฤษ โปรดตรวจเทียบกับต้นฉบับไทย",
    parallelDocumentOnly: "ยังไม่มีการจับคู่ระดับมาตรา",
    chooseEnglish: "เปิดฉบับอังกฤษได้จากตัวเลือกภาษา",
    translationMissing: "ยังไม่มีฉบับแปลที่จับคู่กับส่วนนี้",
    translationMissingDetail: "จึงยังไม่แสดงข้อความแทนต้นฉบับ",
    sectionFallback: "ส่วนอื่นๆ",
    table: "ตาราง",
    citePanelHint: "เปิดเอกสารที่เกี่ยวข้องเมื่อต้องการ โดยไม่ขัดจังหวะการอ่านตัวบท",
    openCited: "เปิดเอกสาร",
    compareCited: "เพิ่มเพื่อเปรียบเทียบ",
    moreCitations: "ดูอีก {{count}} รายการ",
    unresolvedCitations: "อีก {{count}} รายการยังไม่มีเอกสารปลายทาง",
    sourceAvailable: "มีฉบับอ่านสะอาด",
    sourceUnavailable: "ยังไม่พบฉบับอ่านสะอาด",
    copyCitation: "คัดลอกคำอ้างอิง",
    sourceLoading: "กำลังเปิดฉบับอ่านสะอาด…",
    translationNotPaired: "ยังไม่มีส่วนภาษาอังกฤษที่จับคู่ได้",
    ocrImageTitle: "หน้านี้ยังเป็นภาพสแกน",
    ocrImageText: "ยังไม่มีข้อความที่พร้อมแสดง",
    ocrNotice: "ข้อความจากการอ่านภาพ — ตรวจเทียบกับต้นฉบับก่อนใช้อ้างอิง",
    noCitations: "ยังไม่พบเอกสารที่อ้างถึงในส่วนนี้",
    relatedBoth: "กฎหมายลำดับรองและประวัติการแก้ไข",
    relatedAmendment: "ประวัติการแก้ไขและเอกสารที่เกี่ยวข้อง",
    relatedReference: "กฎหมายลำดับรองและเอกสารที่เกี่ยวข้อง",
    documentCount: "{{count}} เอกสาร",
    noteCount: "{{count}} หมายเหตุ",
    openError: "ไม่สามารถเปิดเอกสารนี้ได้",
    citationError: "ไม่สามารถเปิดเอกสารอ้างอิงนี้ได้",
  },
  source: {
    heading: "แหล่งที่มา",
    publisherLink: "เปิดแหล่งเผยแพร่ทางการ",
    preservedFile: "เปิดฉบับอ่านสะอาด",
    citation: "คัดลอกคำอ้างอิง",
    copied: "คัดลอกแล้ว",
    unavailable: "ยังไม่พบข้อมูลแหล่งที่มา",
    noPublisher: "ยังไม่พบแหล่งเผยแพร่ทางการที่เปิดได้",
    noPreservedFile: "ยังไม่พบฉบับอ่านสะอาด",
    readingCopy: "เปิดฉบับอ่านสะอาด",
    download: "ดาวน์โหลดฉบับอ่านสะอาด",
    attachment: "เอกสารแนบ",
    noReadingCopy: "ยังไม่มีฉบับอ่านสะอาด",
    openError: "ไม่สามารถเปิดฉบับอ่านสะอาดได้",
  },
  comparison: {
    aria: "เปรียบเทียบเอกสาร",
    label: "เปรียบเทียบเอกสาร",
    count: "เลือกแล้ว {{count}}/4 ฉบับ",
    clear: "ล้างทั้งหมด",
    back: "กลับไปอ่าน",
    timeline: "ลำดับเอกสารที่กำลังเปรียบเทียบ",
    addDocument: "เพิ่มเอกสาร",
    full: "อ่านทั้งฉบับ",
    fullHint: "เลื่อนดูข้อความทั้งหมดของแต่ละฉบับ",
    section: "เจาะส่วนเดียว",
    sectionHint: "เลือกจากชื่อหัวข้อเพื่อดูทีละส่วน",
    sharedSection: "ส่วนที่ตรงกัน — เลือกครั้งเดียวให้ทุกฉบับตรงกัน",
    alignment: "จับคู่หัวข้อได้ {{matched}} จาก {{total}} ส่วน — ไม่ใช่การวินิจฉัยว่าผลทางกฎหมายเท่ากัน",
    noAlignment: "เปรียบเทียบระดับเอกสารเท่านั้น — ยังไม่มีส่วนที่จับคู่ได้",
    sectionShown: "ส่วนที่แสดง",
    remove: "นำออก",
    emptyLabel: "เอกสารเปรียบเทียบ",
    emptyTitle: "เลือกอีกฉบับเพื่อเปรียบเทียบ",
    emptyHint: "เปิดเอกสารที่อ้างถึง หรือใช้ “เพิ่มเพื่อเปรียบเทียบ” จากหน้าอ่านหลัก",
    source: "แหล่งที่มา",
    noDate: "ยังไม่ระบุวันที่",
    noSection: "ยังไม่พบข้อความที่พร้อมเปรียบเทียบ",
    limitError: "เปรียบเทียบได้สูงสุด 4 ฉบับ — นำฉบับเดิมออกก่อนเพิ่มรายการใหม่",
    search: "ค้นหาเอกสารเพื่อเพิ่ม",
    searchPlaceholder: "ค้นชื่อเรื่อง เลขที่ หรือคำค้น",
    searchSubmit: "ค้นหา",
    chooseDocument: "เลือกเอกสาร",
    noCandidates: "ยังไม่มีผลลัพธ์ให้เลือก",
    addSelected: "เพิ่มเอกสาร",
    notPaired: "ยังจับคู่ส่วนนี้ไม่ได้",
  },
  workProgress: {
    title: "ความคืบหน้าคลังข้อมูล", noCount: "ยังไม่มีผลนับ", awaitingCount: "รอผลประมวลผล",
    connecting: "กำลังเชื่อมต่อสถานะงาน", awaitingAlignment: "อีก {{count}} หน่วยรอจับคู่ฉบับอังกฤษจากผู้เผยแพร่",
    processed: "ประมวลผลแล้ว {{percent}}%", updatedAt: "อัปเดต {{time}}",
    ocr: "อ่านข้อความจากไฟล์ · หน้า", translation: "แปลอังกฤษ · หน่วยข้อความที่พร้อมแปล",
    readyPages: "ผ่านตรวจ {{ready}} · รอตรวจเพิ่ม {{held}} หน้า",
    awaitingCheck: "เพิ่มใหม่ {{count}} หน้า รอรอบตรวจคุณภาพ",
    translationResults: "ผ่านเกณฑ์แปล {{passed}} · ต้องแก้ไข {{held}} หน่วย",
    scope: "แถบแสดงงานที่ประมวลผลแล้ว การเปิดให้อ่านขึ้นกับผลตรวจคุณภาพและความครบของเอกสาร",
    blocked: "อีก {{count}} หน่วยต้องเตรียมต้นฉบับหรือแก้คุณภาพก่อนแปล",
    qualityAt: "ผลตรวจข้อความล่าสุด {{date}}", steps: "ขั้นตอนรอบปัจจุบัน",
    attention: "รอบล่าสุดหยุดระหว่างประมวลผล กำลังตรวจสาเหตุก่อนทำต่อ",
    connection: "เชื่อมต่อสถานะไม่ได้ กำลังเชื่อมต่อใหม่ ตัวเลขด้านล่างเป็นผลล่าสุดที่ได้รับ",
    states: { running: "กำลังดำเนินการ", attention: "งานหยุดรอตรวจสอบ", idle: "รอรอบถัดไป", disconnected: "ขาดการเชื่อมต่อ" },
    stepStates: { done: "เสร็จรอบนี้", active: "กำลังทำ", waiting: "รอ" },
    stages: { rd_snapshot: "ตรวจเอกสารใหม่", classify_scope: "คัดเลือกเอกสาร", archive_ingestion_queue: "เตรียมต้นฉบับ", ocr_blocking: "อ่านข้อความจากไฟล์", public_text_qa: "ตรวจคุณภาพข้อความ", translate_batch: "แปลภาษาอังกฤษ", translation_qa_bundle: "ตรวจคำแปลทั้งฉบับ", citation_mapping: "เชื่อมเอกสารอ้างถึง", index_report_snapshot: "เตรียมคลังสำหรับอ่าน", processing: "กำลังประมวลผลเอกสาร" },
  },
  updates: {
    aria: "ความเคลื่อนไหวกฎหมายล่าสุด",
    new: "มีอะไรใหม่",
    latest: "อัปเดตล่าสุด",
    count: "{{count}} รายการ",
    checked: "ตรวจข้อมูลล่าสุดแล้ว",
    all: "ดูทั้งหมด",
    status: "ดูสถานะ",
    close: "ปิดศูนย์อัปเดต",
    dialog: "ศูนย์อัปเดตกฎหมาย",
    headline: "ความเคลื่อนไหวกฎหมาย",
    newItems: "{{count}} รายการที่ควรทราบ",
    noNew: "ยังไม่พบรายการใหม่",
    checkedAt: "ตรวจล่าสุด {{date}}",
    disclaimer: "รายการนี้ช่วยชี้เอกสารที่มีการเปลี่ยนแปลง แต่ไม่ใช่ข้อสรุปเรื่องผลทางกฎหมาย",
    newKind: "ใหม่",
    changedKind: "ปรับปรุง",
    publisher: "เปิดเอกสารจากกรมสรรพากร",
    empty: "ตรวจแหล่งข้อมูลล่าสุดแล้ว ยังไม่มีรายการให้เปิดอ่าน",
  },
  timeline: {
    aria: "ลำดับเวลาของเอกสาร",
    signed: "ลงนาม",
    issued: "ออกเอกสาร",
    gazette: "ประกาศราชกิจจานุเบกษา",
    effective: "วันที่มีผลใช้บังคับที่บันทึก",
    pageUpdated: "วันที่ปรับปรุงหน้าเผยแพร่",
  },
  translation: {
    original: { badge: "ต้นฉบับภาษาไทย", disclosure: "" },
    originalUnverified: { badge: "ต้นฉบับภาษาไทย", disclosure: "" },
    official: { badge: "ฉบับอังกฤษทางการ", disclosure: "" },
    purposeOnly: { badge: "ฉบับภาษาอังกฤษจากผู้เผยแพร่ (จัดทำเพื่อการแปล)", disclosure: "" },
    unverified: { badge: "ข้อความภาษาอังกฤษ", disclosure: "" },
    reviewed: { badge: "คำแปลภาษาอังกฤษที่ผ่านการตรวจทาน", disclosure: "" },
    edited: { badge: "ร่างคำแปลภาษาอังกฤษที่แก้ไขแล้ว", disclosure: "" },
    draft: { badge: "ร่างคำแปลภาษาอังกฤษ — อยู่ระหว่างการตรวจทาน", disclosure: "" },
    unknown: { badge: "ข้อความภาษาอังกฤษ", disclosure: "" },
  },
};

const EN = {
  header: {
    search: "Search",
    library: "Law library",
    compare: "Compare",
    placeholder: "Search laws, rulings, document numbers, or tax subjects",
    submit: "Search",
    searching: "Searching…",
    language: "Language",
    english: "English",
    type: "Type",
    year: "Year",
    filters: "Search filters",
    all: "All",
    allYears: "All years",
    uiLanguage: "Interface language",
    documentLanguage: "Document language",
    menu: "Main menu",
    searchLabel: "Search laws",
    openFilters: "Show filters",
    closeFilters: "Hide filters",
    activeFilters: "Filters: {{selection}}",
    noActiveFilters: "Filters",
    selectedLanguageThai: "Thai",
    selectedLanguageEnglish: "English",
  },
  common: {
    close: "Close",
    back: "Back",
    loading: "Loading…",
    unknown: "Not stated",
    notAvailable: "Not available",
    open: "Open",
    copy: "Copy",
    copied: "Copied",
    source: "Source",
    publisher: "Source",
    preservedFile: "Clean reading copy",
    citation: "Citation",
    noLink: "No openable link found",
    noFile: "No clean reading copy found",
    readingCopy: "Clean reading copy",
    download: "Download clean reading copy",
  },
  browse: {
    aria: "Browse the law library",
    eyebrow: "Browse the law library",
    title: "Explore tax law",
    paths: "Browse options",
    retry: "Try loading the library again",
    root: "Legal hierarchy",
    breadcrumb: "Location in law library",
    loading: "Loading the law library…",
    catalogError: "The law library could not be loaded",
    listError: "Documents in this collection could not be loaded",
    revenueError: "The Revenue Code contents could not be loaded",
    allYears: "View all years",
    undatedYear: "Year not stated",
    undatedHelp: "View documents without a stated year",
    yearHelp: "View the document list",
    sections: "sections",
    subsections: "subsections",
    source: "Source",
    detailContents: "Detailed contents",
    selectWithoutSearch: "Choose a collection without searching",
  },
  results: {
    aria: "Search results",
    eyebrow: "Search results",
    count: "{{count}} results",
    sort: "Sort results",
    relevance: "Most relevant",
    newest: "Newest first",
    oldest: "Oldest first",
    byType: "By type",
    byYear: "By year",
    empty: "No matching documents",
    start: "Start with a search term or document number",
    description: "Searches document text, not titles alone",
    searchError: "Search failed. Please try again",
    underReview: "Under review",
    approved: "Reviewed",
    undated: "Year not stated",
  },
  reader: {
    loading: "Loading document…",
    empty: "Choose a document to read its text and check its source",
    backSearch: "Back to search results",
    backBrowse: "Back to law library",
    fontSize: "Text size",
    decreaseFont: "Decrease text size",
    resetFont: "Reset text size",
    increaseFont: "Increase text size",
    focusOn: "Back to research view",
    focusOff: "Full reading mode",
    hideOutline: "Hide outline",
    showOutline: "Show outline",
    continuousOn: "Continuous reading",
    continuousOff: "One section at a time",
    addCompare: "+ Add to comparison",
    citedDocuments: "Cited documents",
    sourceAndRelated: "Source",
    toolbar: "Document reading tools",
    structureAndContext: "Structure and context",
    documentDates: "Document dates",
    textUnavailable: "Readable text is not yet available. Open Source to view the publisher’s document.",
    applicableLaw: "Applicable law",
    question: "Question",
    holding: "Holding",
    page: "Page",
    preamble: "Preamble",
    provision: "Provision",
    parties: "Parties",
    issue: "Issue",
    sourceAttribution: "Source attribution",
    outline: "Document outline",
    outlineTitle: "Document structure",
    documentParts: "Document sections",
    thai: "Thai",
    english: "English",
    parallel: "Thai–English",
    parallelSide: "Thai–English reading side",
    languageControlNote: "Choose a language to read an available edition",
    translationTitle: "English title",
    titleInThai: "Thai-language title",
    titleInEnglish: "English-language title",
    thaiOriginalOnly: "Thai original only",
    translationDraft: "This is a draft English title. Check it against the Thai original",
    parallelDocumentOnly: "No section-level pairing is available",
    chooseEnglish: "Open the English edition from the language switch",
    translationMissing: "No English edition is paired with this section",
    translationMissingDetail: "No substitute text is shown for the original",
    sectionFallback: "Other section",
    table: "Table",
    citePanelHint: "Open a related document when needed without interrupting the text",
    openCited: "Open document",
    compareCited: "Add to comparison",
    moreCitations: "View {{count}} more",
    unresolvedCitations: "{{count}} more items have no destination document yet",
    sourceAvailable: "Clean reading copy available",
    sourceUnavailable: "No clean reading copy found",
    copyCitation: "Copy citation",
    sourceLoading: "Opening clean reading copy…",
    translationNotPaired: "No English segment is paired with this section",
    ocrImageTitle: "This page is a scanned image",
    ocrImageText: "Readable text is not available yet",
    ocrNotice: "Text from image reading — check the preserved source before citing",
    noCitations: "No cited document is listed for this section",
    relatedBoth: "Subordinate law and amendment history",
    relatedAmendment: "Amendment history and related documents",
    relatedReference: "Subordinate law and related documents",
    documentCount: "{{count}} documents",
    noteCount: "{{count}} notes",
    openError: "This document could not be opened",
    citationError: "The cited document could not be opened",
  },
  source: {
    heading: "Source",
    publisherLink: "Open official source",
    preservedFile: "Open clean reading copy",
    citation: "Copy citation",
    copied: "Copied",
    unavailable: "Source information is not available",
    noPublisher: "No openable official source found",
    noPreservedFile: "No clean reading copy found",
    readingCopy: "Open clean reading copy",
    download: "Download clean reading copy",
    attachment: "Attachment",
    noReadingCopy: "No clean reading copy is available",
    openError: "The clean reading copy could not be opened",
  },
  comparison: {
    aria: "Compare documents",
    label: "Document comparison",
    count: "{{count}}/4 selected",
    clear: "Clear all",
    back: "Back to reading",
    timeline: "Documents being compared",
    addDocument: "Add document",
    full: "Read full documents",
    fullHint: "View all text in each edition",
    section: "Single section",
    sectionHint: "Choose a heading to read one section",
    sharedSection: "Matching section — choose once for every edition",
    alignment: "{{matched}} of {{total}} sections share a heading — this is not a legal-effect determination",
    noAlignment: "Document-level comparison only — no matching section was found",
    sectionShown: "Displayed section",
    remove: "Remove",
    emptyLabel: "Comparison document",
    emptyTitle: "Choose another document to compare",
    emptyHint: "Open a cited document or use “Add to comparison” in the reader",
    source: "Source",
    noDate: "Date not stated",
    noSection: "No readable text is available for comparison",
    limitError: "You can compare up to four documents. Remove one before adding another",
    search: "Find a document to add",
    searchPlaceholder: "Search a title, number, or phrase",
    searchSubmit: "Search",
    chooseDocument: "Choose a document",
    noCandidates: "No results to choose from",
    addSelected: "Add document",
    notPaired: "This section is not paired",
  },
  workProgress: {
    title: "Library progress", noCount: "Not yet counted", awaitingCount: "Awaiting processing results",
    connecting: "Connecting to work status", awaitingAlignment: "{{count}} units await matching to publisher English texts",
    processed: "{{percent}}% processed", updatedAt: "Updated {{time}}",
    ocr: "Read source files · pages", translation: "English translation · eligible text units",
    readyPages: "Passed checks {{ready}} · Further review {{held}} pages",
    awaitingCheck: "{{count}} newly processed pages await the next quality check",
    translationResults: "Passed checks {{passed}} · Needs correction {{held}} units",
    scope: "Bars show processing progress. Reading availability depends on quality checks and document completeness.",
    blocked: "Another {{count}} units need source preparation or quality corrections before translation",
    qualityAt: "Latest text quality check: {{date}}", steps: "Current round",
    attention: "The last round stopped during processing. Its cause needs checking before work continues.",
    connection: "Status connection lost. Reconnecting; figures below are the last received results.",
    states: { running: "Work in progress", attention: "Work needs attention", idle: "Waiting for the next round", disconnected: "Connection lost" },
    stepStates: { done: "Done this round", active: "In progress", waiting: "Waiting" },
    stages: { rd_snapshot: "Check new documents", classify_scope: "Select relevant documents", archive_ingestion_queue: "Prepare source files", ocr_blocking: "Read source files", public_text_qa: "Check text quality", translate_batch: "Translate into English", translation_qa_bundle: "Check complete translations", citation_mapping: "Connect cited documents", index_report_snapshot: "Prepare the reading library", processing: "Processing documents" },
  },
  updates: {
    aria: "Latest legal updates",
    new: "New items",
    latest: "Latest update",
    count: "{{count}} items",
    checked: "Latest information checked",
    all: "View all",
    status: "View status",
    close: "Close updates",
    dialog: "Legal updates",
    headline: "Legal activity",
    newItems: "{{count}} items to review",
    noNew: "No new items",
    checkedAt: "Checked {{date}}",
    disclaimer: "These items help identify changed documents; they are not a conclusion about legal effect",
    newKind: "New",
    changedKind: "Updated",
    publisher: "Open the Revenue Department document",
    empty: "The latest sources were checked; there are no items to open",
  },
  timeline: {
    aria: "Document timeline",
    signed: "Signed",
    issued: "Issued",
    gazette: "Gazette publication",
    effective: "Recorded effective date",
    pageUpdated: "Published-page update",
  },
  translation: {
    original: { badge: "Thai original", disclosure: "" },
    originalUnverified: { badge: "Thai original", disclosure: "" },
    official: { badge: "Official English edition", disclosure: "" },
    purposeOnly: { badge: "Publisher English edition (for translation)", disclosure: "" },
    unverified: { badge: "English text", disclosure: "" },
    reviewed: { badge: "Reviewed English translation", disclosure: "" },
    edited: { badge: "Edited English translation draft", disclosure: "" },
    draft: { badge: "English translation draft — under review", disclosure: "" },
    unknown: { badge: "English text", disclosure: "" },
  },
};

export const LOCALE_CATALOG = { th: TH, en: EN };

export function getLocaleMessage(locale, key, variables = {}) {
  const fallbackCatalog = locale === "en" ? EN : TH;
  const messages = LOCALE_CATALOG[locale]?.[key.split(".")[0]] || fallbackCatalog[key.split(".")[0]] || {};
  const value = key.split(".").slice(1).reduce((current, part) => current?.[part], messages);
  const fallback = key.split(".").slice(1).reduce((current, part) => current?.[part], fallbackCatalog[key.split(".")[0]]);
  const template = typeof value === "string" ? value : typeof fallback === "string" ? fallback : key;
  return template.replace(/\{\{(\w+)\}\}/g, (_, name) => String(variables[name] ?? ""));
}

export function getTranslationMessage(locale, key) {
  return LOCALE_CATALOG[locale]?.translation?.[key]
    || (locale === "en" ? EN.translation.unknown : TH.translation.unknown);
}

export function localeTag(locale) {
  return locale === "en" ? "en-US" : "th-TH-u-ca-buddhist";
}

export function formatCount(value, locale = "th") {
  return Number(value || 0).toLocaleString(localeTag(locale));
}
